import { render, staticRenderFns } from "./TourCard.vue?vue&type=template&id=76d63063&scoped=true"
import script from "./TourCard.vue?vue&type=script&lang=js"
export * from "./TourCard.vue?vue&type=script&lang=js"
import style0 from "./TourCard.vue?vue&type=style&index=0&id=76d63063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d63063",
  null
  
)

export default component.exports